import { CATEGORY_MODEL_FOLDER, CATEGORY_PREFIX, type AssetManifestEntry } from './AssetTypes';

/** Asset ids: PREFIX_NAME[_VARIANT], upper snake case (see NAMING_CONVENTIONS.md). */
export const ASSET_ID_PATTERN = /^[A-Z]{2,4}_[A-Z0-9]+(?:_[A-Z0-9]+)*$/;

/**
 * Validates manifest consistency. Runs in unit tests and at startup in dev
 * builds – broken manifests must fail loudly, never at the first spawn.
 */
export function validateAssetManifest(entries: readonly AssetManifestEntry[]): string[] {
  const errors: string[] = [];
  const seen = new Set<string>();

  for (const entry of entries) {
    const where = `[${entry.id}]`;
    if (seen.has(entry.id)) errors.push(`${where} duplicate asset id`);
    seen.add(entry.id);

    if (!ASSET_ID_PATTERN.test(entry.id)) errors.push(`${where} id does not match ${ASSET_ID_PATTERN}`);

    const prefix = CATEGORY_PREFIX[entry.category];
    if (!entry.id.startsWith(`${prefix}_`)) errors.push(`${where} category "${entry.category}" requires prefix ${prefix}_`);

    if (entry.source.kind === 'greybox') {
      if (entry.source.parts.length === 0) errors.push(`${where} greybox without parts`);
      for (const part of entry.source.parts) {
        if (part.size.some((s) => !(s > 0))) errors.push(`${where} greybox part with non-positive size`);
      }
    } else {
      const expected = `/assets/models/${CATEGORY_MODEL_FOLDER[entry.category]}/${entry.id.toLowerCase()}.glb`;
      if (entry.source.url !== expected) errors.push(`${where} GLB url must be ${expected} (is ${entry.source.url})`);
    }

    for (const lod of entry.lods ?? []) {
      if (!/_lod\d\.glb$/.test(lod.url)) errors.push(`${where} LOD url must end with _lod<N>.glb`);
    }
  }
  return errors;
}
